var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "flexbox",
    {
      staticClass: "wk-form-items",
      attrs: { align: "flex-start", wrap: "wrap", justify: "flex-start" },
    },
    [
      _vm._l(_vm.fieldList, function (item, index) {
        return [
          _c("wk-form-item", {
            key: index,
            attrs: {
              "prop-prefix": _vm.propPrefix,
              item: item,
              index: index,
              "field-from": _vm.fieldFrom,
              "ignore-fields": _vm.ignoreFields,
              disabled: _vm.disabled,
            },
            on: { change: _vm.fieldChange },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ data, index }) {
                    return [
                      _vm._t("default", null, { data: item, index: index }),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }